<template lang="pug">
  b-container.white-space(fluid="fluid")
    b-form-text.my-2.align-left.text-left.error-message-color(v-for="(message, key) of error_msg_list", :key="key") {{message}}
    b-row
      b-col
        h5#chat-user.mt-3.font-weight-bold.ml-3.form-inline(:class="title_class")
          label ビジネスチャット ChatLuck（1ユーザー￥330/月）
        b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="chat.label", :label-class="chat.label_class", :class="data_class")
          .form-inline
            b-form-input.mb-2(size="sm", :type="chat.type", v-model="value.chat_user", :state="chat.error_msg.length === 0 ? null : false", :placeholder="chat.placeholder")
            b-form-text.ml-1.mb-2 ユーザー
          b-form-text.error-text-position.mb-1.error-message-color(v-for="(error_msg) of chat.error_msg") {{error_msg}}
          b-form-text.description-text-position {{chat.description}}
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
        //- オプションサービス
        h5#chat-option-service.font-weight-bold.ml-3.mb-3(:class="title_class")
          b-form-checkbox(v-model="value.option", @change="toggleOptionService") オプションサービス
        b-collapse#collapse-option-service(v-model="optionServiceIsOpen")
          // ディスク増設
          b-form-checkbox.ml-4(v-model="value.disk", @change="toggleDisk", :class="option_data_class")
            .form-inline
              b-form-text.label-font-size.mt-0 {{option_disk.label}}
          b-collapse#collapse-option-disk.sub-b-collapse(v-model="optionDiskIsOpen")
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="option_disk_size.label", :label-class="option_disk_size.label_class")
              .form-inline
                b-form-text.mb-2.mx-1 20GB ×
                b-form-input.mb-2.option-disk-form-class(size="sm", :type="option_disk_size.type", v-model="value.disk_size", :state="option_disk_size.error_msg.length === 0 ? null : false", @input="changeSumSize")
                b-form-text.mb-2.mx-1 =
                b-form-text.mb-2.mx-1 {{option_disk_sum}}GB 増設
              b-form-text.error-text-position.mb-1.error-message-color(v-for="(error_msg) of option_disk_size.error_msg") {{error_msg}}
          b-form-group.ml-4.border-top.border-success(style="height: 0px;")
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
        //- セキュリティオプション
        h5#chat-security-option.font-weight-bold.ml-3.mb-3(:class="title_class")
          b-form-checkbox(v-model="value.security" @change="toggleSecurityOption") セキュリティオプション
        b-collapse#collapse-security-option(v-model="securityOptionIsOpen")
          // BASIC認証
          b-form-checkbox.ml-4(v-model="value.basic", @change="toggleBasic", :class="option_data_class", :state="basic_auth.error_msg.length === 0 ? null : false") {{basic_auth.label}}
          b-form-text.ml-3.text-left.error-message-color(v-for="(error_msg) of basic_auth.error_msg") {{error_msg}}
          b-collapse#collapse-basic.sub-b-collapse(v-model="basicIsOpen")
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="basic_auth_user.label", :label-class="basic_auth_user.label_class")
              .form-inline
                b-form-input(size="sm", :type="basic_auth_user.type", v-model="value.basic_id", :state="basic_auth_user.error_msg.length === 0 ? null : false", :placeholder="basic_auth_user.placeholder")
              b-form-text.error-text-position.mb-1.error-message-color(v-for="(error_msg) of basic_auth_user.error_msg") {{error_msg}}
            b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="basic_auth_password.label", :label-class="basic_auth_password.label_class")
              .form-inline
                b-form-input(size="sm", :type="basic_auth_password.type", v-model="value.basic_password", :state="basic_auth_password.error_msg.length === 0 ? null : false", :placeholder="basic_auth_password.placeholder")
              b-form-text.error-text-position.mb-1.error-message-color(v-for="(error_msg) of basic_auth_password.error_msg") {{error_msg}}
            b-form-group.white-space.align-content.mt-2(label-cols="12", label-align="left", label-size="sm", :label="basic_auth_ip.label", :label-class="basic_auth_ip.label_class")
              b-form-textarea(v-model="value.basic_except_ip", :state="basic_auth_ip.error_msg.length === 0 ? null : false", rows="4")
              b-form-text.error-text-position.mb-1.error-message-color(v-for="(error_msg) of basic_auth_ip.error_msg") {{error_msg}}
              b-form-text.mt-0 {{basic_auth_ip.description}}
          // 接続元IPアドレス制限
          b-form-checkbox.ml-4(v-model="value.connect_permit", @change="toggleIpRestrictions", :state="ip_restrictions.error_msg.length === 0 ? null : false", :class="option_data_class") {{ip_restrictions.label}}
          b-form-text.ml-3.text-left.error-message-color(v-for="(error_msg) of ip_restrictions.error_msg") {{error_msg}}
          b-collapse#collapse-ip-restrictions.sub-b-collapse(v-model="ipRestrictionsIsOpen")
            b-form-group.white-space.align-content(label-cols="12", label-align="left", label-size="sm", :label="ip_restrictions_ip.label", :label-class="ip_restrictions_ip.label_class")
              b-form-textarea(v-model="value.connect_permit_ip", :state="ip_restrictions_ip.error_msg.length === 0 ? null : false", rows="4")
              b-form-text.error-text-position.mb-1.error-message-color(v-for="(error_msg) of ip_restrictions_ip.error_msg") {{error_msg}}
              b-form-text.mt-0 {{ip_restrictions_ip.description}}
          b-form-group.ml-4.border-top.border-success(style="height: 0px;")
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px")
        // ご希望サブドメイン名
        h5.font-weight-bold.ml-3#chat-sub-domain(:class="title_class") ご希望サブドメイン名
        b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="sub_domain.label", :label-class="sub_domain.label_class")
          .form-inline
            b-form-input.mb-2(size="sm", :type="sub_domain.type", v-model="value.sub_domain", :state="sub_domain.error_msg.length === 0 ? null : false", :placeholder="sub_domain.placeholder", @change="domainCheck")
            b-form-text.ml-1.mb-2 .chatluck.net
          b-form-text.error-text-position.mb-1.error-message-color(v-for="(error_msg) of sub_domain.error_msg") {{error_msg}}
          b-form-text.description-text-position {{sub_domain.description}}
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px")
        // 無料お試し版からのデータ移行
        h5#chat-migration.font-weight-bold.ml-3(:class="title_class") 無料お試し版からのデータ移行
        b-form-checkbox.ml-4(v-model="value.migration", @change="toggleMigration")
          .form-inline
            b-form-text.label-font-size.mt-0 {{migration.label}}
          b-form-text.font-weight-bold(text-variant="danger") {{migration.description}}
        b-collapse#collapse-migration.sub-b-collapse(v-model="migrationIsOpen")
          b-form-group.align-content.mt-2(label-cols="4", label-align="right", label-size="sm", :label="migration_url.label", :label-class="migration_url.label_class")
            b-form-input(size="sm", type="text", v-model="value.migration_url", :state="migration_url.error_msg.length === 0 ? null : false", :placeholder="migration_url.placeholder", maxlength="128")
            b-form-text.error-text-position.mb-1.error-message-color(v-for="(error_msg) of migration_url.error_msg") {{error_msg}}
            //.form-inline
            //  b-form-text 試使用環境のURLをコピーする方法は
            //  a(href="/migration_help.html", style="font-size: 80%; margin-top: 4px;", target="_blank") こちら
            //  b-form-text から
          b-form-group.white-space.align-content.mt-2.ml-3(label-cols="5", label-align="right", label-size="sm", :label="migration_choice.label", :label-class="migration_choice.label_class")
            .form-inline
              b-button.mb-2(v-b-modal.select_datetime, variant="outline-secondary", size="sm", title="選択") 選択
              select-datetime(v-model="migration_datetime.value", @done="setDateTime")
          b-form-group.align-content.mt-2.ml-3(label-cols="5", label-align="right", label-size="sm", :label="migration_datetime.label", :label-class="migration_datetime.label_class")
            b-form-text.mb-2.datetime-text {{showMigrationTime}}
            b-form-text.error-text-position.mb-1.error-message-color(v-for="(error_msg) of migration_datetime.error_msg") {{error_msg}}
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px")
        div(v-if="!migrationIsOpen")
          // ご利用開始希望日
          h5#preferred-date.font-weight-bold.ml-3(:class="title_class") ご利用開始希望日
          b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="preferred_date.label", :label-class="preferred_date.label_class")
            b-form-datepicker.mb-2.datepicker-size(
              size="sm",
              v-model="value.preferred_date",
              :min="preferred_date.min",
              :max="preferred_date.max",
              :placeholder="preferred_date.placeholder",
              :hide-header="true",
              :date-format-options="preferred_date.format_option"
              :date-disabled-fn="dateDisabled"
            )
            b-form-text.error-text-position.mb-1.error-message-color(v-for="(error_msg) of preferred_date.error_msg") {{error_msg}}
            b-form-text.description-text-position {{preferred_date.description}}
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px")
        // お見積番号
        h5#chat-estimate.font-weight-bold.ml-3(:class="title_class") お見積番号
        b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="estimate.label", :label-class="estimate.label_class")
          .form-inline
            b-form-text.mr-1 No.
            b-form-textarea.mb-2.estimate-size(v-model="value.estimate", :state="estimate.error_msg.length === 0 ? null : false", rows="3")
          b-form-text.error-text-position.mb-1.error-message-color(v-for="(error_msg) of estimate.error_msg") {{error_msg}}
          b-form-text.description-text-position(text-variant="danger") {{estimate.description_1}}
          b-form-text.description-text-position {{estimate.description_2}}
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px")
        // 備考
        h5#chat-remarks.font-weight-bold.ml-3(:class="title_class") 備考
        b-container.sub-b-container
          b-form-group.white-space.align-content(label-cols="12", label-align="left", label-size="sm", :label="remarks.label", :label-class="remarks.label_class")
            b-form-textarea(v-model="value.remarks", rows="4")
            b-form-text.error-text-position.mb-1.error-message-color(v-for="(error_msg) of remarks.error_msg") {{error_msg}}
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
    b-row
      b-col
        // サービス利用約款など
        h5#chat-provision.font-weight-bold.ml-3(:class="title_class") サービス利用約款など
        b-container.sub-b-container
          p
            a(href="https://www.chatluck.com/terms/tos-cloud.pdf", target="_blank") ＞ ChatLuckクラウドサービス利用約款
          p
            b-link(href="/tos.pdf", target="_blank") ＞ クラウド版サポートサイト利用規約
          b-form-textarea.white-space(v-model="provision.value", :disabled="true", rows="6")
          b-form-group.mt-3.mb-0.align-content.text-danger(label-cols="12", label-align="left", label-size="sm", :label="provision.label")
          b-form-checkbox.mx-auto(v-model="value.provision", :state="provision_check.error_msg.length === 0 ? null : false", :disabled="isLoading") {{provision_check.label}}
          b-form-text.error-text-position.mb-1.error-message-color(v-for="(error_msg) of provision_check.error_msg") {{error_msg}}
    b-button.float-left.ml-5.my-3(pill, variant="outline-secondary", size="lg", :to="{name: 'ApplyPlan'}")
      .float-right.search_message.ml-1.font-weight-bold 戻る
      b-icon.float-left.next-icon(icon="arrow-left-circle")
    b-button.float-right.mr-5.my-3(pill, :variant="!value.provision || isLoading ? 'outline-secondary' : 'outline-primary'", size="lg", :disabled="!value.provision || isLoading", @click="contractOrderCheck")
      .float-left.search_message.mr-1.font-weight-bold 次へ
      b-icon.float-right.next-icon(icon="arrow-right-circle")
</template>

<script>
/* eslint-disable */
import SelectDatetime from "@/components/firstOrder/SelectDatetime";
import Api from "@/repositories/api";

const c204SubdomainCheckRepository = Api.get("c204SubdomainCheck")

const s205ChatContractOrderRepository = Api.get("s205ChatContractOrder")

export default {
  name: "ContractChatForm",
  components: {
    SelectDatetime,
  },
  props: {
    value: { type: Object, required: false }
  },
  // 画面表示時処理（DOM作成前に実行）
  created() {
    // 今日の日付の取得
    let currentDate = new Date();

    // 開始日(Dateオブジェクト)
    let startDate = new Date(currentDate);
    // 開始日(YYYY-MM-DD)
    let formedStartDate = ''

    // 祝日データを取得
    const holiday = this.getHolidays()

    // 本日から空ける必要のある営業日数(N日目が開始日)
    let preparationCount = this.getPreparationDayCount()

    // datepickerの最小値を作成
    for (let i = 0; i <= preparationCount; i++) {
      // 最後の日が休日の場合に開始日を進める必要があるので、比較にイコールを含む

      // YYYY-MM-DD の形式にする
      formedStartDate =  startDate.getFullYear()
          + "-" + ("00" + (startDate.getMonth() + 1)).slice(-2)
          + "-" + ("00" + startDate.getDate()).slice(-2)

      // 土曜日または日曜日または祝日の場合はスキップ
      if (startDate.getDay() === 6 || startDate.getDay() === 0 || holiday.includes(formedStartDate) === true) {
        i--
      }

      // 最終日ではない場合は翌日へ
      if (i < preparationCount) {
        startDate.setDate(startDate.getDate() + 1)
      }
    }
    this.preferred_date.min = formedStartDate

    // datepickerの最大値を作成
    let maxDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0)
    this.preferred_date.max = maxDate.getFullYear()
      + "-" + ("00" + (maxDate.getMonth() + 1)).slice(-2)
      + "-" + ("00" + maxDate.getDate()).slice(-2)
  },
  /**
   * DOM作成後に実行される処理
   */
  mounted() {
    // アンカーまでスクロールする
    this.scrollToAnchor(this.$route.hash)
  },
  data() {
    // 必須のラベル
    const required_label_class = "py-05 mb-4 required-label-after";

    // 任意のラベル
    const elective_label_class = "py-05 mb-4 elective-label-after";

    return {
      optionServiceIsOpen: this.value.option,
      optionDiskIsOpen: this.value.disk,
      securityOptionIsOpen: this.value.security,
      basicIsOpen: this.value.basic,
      ipRestrictionsIsOpen: this.value.connect_permit,
      migrationIsOpen: this.value.migration,

      option_disk_sum: 0,

      title_class: "border-top border-bottom chat-title-bg-color py-2",
      data_class: "ml-3 py-2 px-2 mb-2 border-top border-bottom border-success label-font-size",

      option_data_class: "py-2 border-top border-success",
      option_data_last_class: "py-2 border-top border-bottom border-success",

      chat: {
        label: "ユーザー数",
        label_class: required_label_class,
        type: "text",
        placeholder: "（半角数字）",
        description: "※最低契約ユーザー数は5ユーザーです。\n※ご契約単位は1ユーザー単位です。",
        error_msg: [],
      },

      option_service: {
        checked: false,
      },
      option_disk: {
        label: "ディスク増設（20GBあたり￥1,100/月）",
      },
      option_disk_size: {
        label: "増設容量",
        label_class: required_label_class,
        type: "text",
        error_msg: [],
      },

      basic_auth: {
        checked: false,
        label: "BASIC認証（無償）",
        error_msg: []
      },
      basic_auth_user: {
        label: "ユーザーID",
        label_class: required_label_class,
        type: "text",
        placeholder: "（半角英数字）",
        error_msg: [],
      },
      basic_auth_password: {
        label: "パスワード",
        label_class: required_label_class,
        type: "password",
        placeholder: "（半角英数字）",
        error_msg: [],
      },
      basic_auth_ip: {
        label: "認証を除外するIPアドレス（1行に1件ずつ記入、最大50件まで）",
        label_class: "elective-label-after",
        description: "※記入例：\n" +
          "　特定のIPアドレスからの接続は認証しない：192.0.2.201\n" +
          "　特定のネットワークからの接続は認証しない：192.0.2.0/24",
        error_msg: [],
      },
      ip_restrictions: {
        label: "接続元IPアドレス制限（無償）",
        error_msg: []
      },
      ip_restrictions_ip: {
        label: "接続を許可するIPアドレス（1行に1件ずつ記入、最大50件まで）",
        label_class: "required-label-after",
        description: "※記入例：\n" +
          "　特定のIPアドレスからの接続を許可する：192.0.2.201\n" +
          "　特定のネットワークからの接続を許可する：192.0.2.0/24",
        error_msg: [],
      },

      sub_domain: {
        label: "サブドメイン名",
        label_class: required_label_class,
        type: "text",
        placeholder: "",
        description: "※お客さまを識別するアクセスURLの一部になります。\n" +
          "※半角ハイフンのサブドメイン先頭および末尾への使用、また半角アンダースコアの使用はできません。",
        error_msg: [],
      },

      estimate: {
        label: "お見積番号",
        label_class: elective_label_class,
        description_1: "既に弊社から見積を取得されている場合、必ずご記入ください。",
        description_2: "※見積書が複数ある場合、改行区切りですべての見積もり番号をご記入ください。",
        error_msg: [],
      },

      migration: {
        checked: false,
        label: "希望する",
        description: "※移行作業中は試使用環境が停止します。",
        error_msg: [],
      },
      migration_url: {
        label: "試使用環境URL",
        label_class: required_label_class + " px-0",
        placeholder: "https://trial-v0r3.chatluck.net/cgi-bin/123456/chatlk/chat.cgi",
        error_msg: [],
      },
      migration_choice: {
        label: "作業日時を選択してください",
        label_class: required_label_class,
      },
      migration_datetime: {
        label: "選択日時",
        label_class: "py-05 mb-4 datetime-label",
        value: {
          date: '',
          start_time: '',
          end_time: '',
        },
        error_msg: [],
      },

      preferred_date: {
        label: "希望日",
        label_class: required_label_class,
        placeholder: "（カレンダーから選択）",
        min: "",
        format_option: {
          year: "numeric",
          month: "long",
          day: "numeric",
        },
        description: "※弊社でお申込書受領後、3～4営業日ほどお時間いただいております。\n" +
          "※ご利用開始希望日が弊社休業日の場合、翌営業日のご希望として承ります。\n" +
          "※ご利用開始希望日は目安として承りますので、ご希望に添えない場合がございます。ご了承ください。",
        error_msg: [],
      },

      remarks: {
        label: "弊社への連絡事項などございましたら、こちらにご記入ください。",
        label_class: "elective-label-after",
        error_msg: [],
      },

      provision: {
        label: "お申込みいただくにあたり、上記の各条項にご同意ください。",
        value: "個人情報の取得目的\n" +
          "１．当社は、当Webサイトにおいて、下記に記載する目的でお客さまより個人情報をご提供いただきます。\n" +
          "　①　お客さまからの資料請求、お問合せ、製品購入申込み等々に対する当社からの返信・送付\n" +
          "　②　当社からの製品情報（新製品やバージョンアップなど）、キャンペーン情報、セミナー情報などのご案内のダイレクトメール（電子メールを含む）の送付および製品に関するその他の情報提供\n" +
          "　③　サービスと製品開発のための統計用データとしての利用\n" +
          "　④　カスタマーハラスメント等への対応・事実確認\n" +
          "\n" +
          "\n" +
          "反社会的勢力の排除について\n" +
          "１．お客さまは、現在または将来にわたって、下記のいずれにも該当しないことを表明、確約するものとします。\n" +
          "　①　暴力団\n" +
          "　②　暴力団員\n" +
          "　③　暴力団員でなくなった時から５年を経過しない者\n" +
          "　④　暴力団準構成員\n" +
          "　⑤　暴力団関係企業\n" +
          "　⑥　総会屋等、社会運動標ぼうゴロまたは特殊知能暴力集団\n" +
          "　⑦　その他上記各号に準ずるもの\n" +
          "２．お客さまは、自らまたは第三者を利用し、下記のいずれかに該当する行為を行わないことを表明、確約するものとします。\n" +
          "　①　暴力的な要求行為\n" +
          "　②　法的な責任を超えた不当な要求行為\n" +
          "　③　取引に関して、脅迫的な言動をし、または暴力を用いる行為\n" +
          "　④　風説を流布し、偽計または威力を用いて当社の信用を毀損し、または当社の業務を妨害する行為\n" +
          "　⑤　その他上記各号に準ずる行為\n" +
          "３．お客さまが上記各項のいずれかに反したと認められることが判明した場合、および上記各項の表明、確約が虚偽の申告であることが判明した場合、当社は、催告その他の手続を要しないで、契約の解除その他の当社が必要と判断する対応をとることができます。\n" +
          "４．お客さまは、前項による契約の解除等について、一切異議を申し立てず、また賠償ないし補償を求めないとともに、これより当社に損害が生じた場合は、これを賠償するものします。\n" +
          "\n" +
          "\n" +
          "管轄裁判所\n" +
          "１．本条項に基づく契約は日本法に準拠し、お客さまと当社の間で訴訟の必要が生じた場合には、訴額に応じて、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。"
      },
      provision_check: {
        label: "上記の条項に同意します。",
        error_msg: [],
      },

      // 画面上部のエラーメッセージ
      error_msg_list: [],

      // エラー発生時のスクロール先
      errorHash: ''
    }
  },
  methods: {
    toggleOptionService() {
      this.optionServiceIsOpen = !this.optionServiceIsOpen;
    },
    toggleDisk() {
      this.optionDiskIsOpen = !this.optionDiskIsOpen;
    },
    changeSumSize(value) {
      // 数値ではない場合、0を出力する
      if (isNaN(value)) {
        this.option_disk_sum = 0;
      }
      // 数値の場合は通常通り計算する
      else {
        this.option_disk_sum = value * 20;
      }
    },
    toggleSecurityOption() {
      this.securityOptionIsOpen = !this.securityOptionIsOpen;
    },
    toggleBasic(){
      this.basicIsOpen = !this.basicIsOpen;
    },
    toggleIpRestrictions() {
      this.ipRestrictionsIsOpen = !this.ipRestrictionsIsOpen;
    },
    toggleMigration() {
      this.migrationIsOpen = !this.migrationIsOpen;
    },
    /**
     * サブドメインチェック処理を行う
     */
    domainCheck() {
      // 初期化
      let sSubdomainName = ""
      let sSubdomainType = ""

      // サブドメインチェック処理のエラーメッセージを空にする
      this.sub_domain.error_msg = []

      // 変数にChatLuckのサブドメイン名の値を代入する
      sSubdomainName = this.value.sub_domain
      sSubdomainType = "1"

      // サブドメインチェック処理を呼び出す
      c204SubdomainCheckRepository.get(encodeURIComponent(sSubdomainName), sSubdomainType)
      .catch((err) => {
        // 共通のエラー処理
        this.apiError(err, "入力チェック処理", "ContractChat")

        // エラーメッセージを生成する
        if (err.response !== null && err.response !== undefined) {
          const errList = err.response.data.error_list
          let target = "sub_domain"
          errList.forEach((sErrorMessage) => {
            this.responseErrorMessage(target, sErrorMessage.error_msg)
          })
        }
      })
    },
    setDateTime() {
      // モーダルでOKボタンが押下されたら、選択した作業日時を設定値にする
      this.value.migration_date = this.migration_datetime.value.date
      // propsのmigration_fromにデータ移行作業時刻（から）を保存する
      this.value.migration_time_from = this.migration_datetime.value.start_time
      // propsのmigration_toにデータ移行作業時刻（まで）を保存する
      this.value.migration_time_to = this.migration_datetime.value.end_time
    },
    dateDisabled(ymd, date) {
      // 曜日の取得
      const weekday = date.getDay()

      // 各日付の「YYYY-mm-dd」形式
      const day = date.getFullYear()
          + "-" + ("00" + (date.getMonth() + 1)).slice(-2)
          + "-" + ("00" + date.getDate()).slice(-2)

      // 祝日データを取得
      const holiday = this.getHolidays()

      return weekday === 0 || weekday === 6 || holiday.includes(day)
    },
    contractOrderCheck() {
      // エラー表示をリセットする
      this.resetError()
      // 送信パラメータの作成
      let arRequestData = this.createRequestData()

      // 次へボタンをロックする
      this.isLoading = true;

      // API呼び出し
      s205ChatContractOrderRepository.check(arRequestData)
      .then((response) => {
        // 請求単位を設定する
        this.value.contract_type = Number(response.data.contract_type)

        // ChatLuckご契約お申込内容確認画面に移動
        this.$router.push({
          name: "ContractChatConfirm"
        });
      })
      .catch((err) => {
        // 次へボタンをロックを解除する
        this.isLoading = false;

        // 共通のエラー処理
        this.apiError(err, "入力チェック処理", "ContractChat")

        // httpステータスコードが403の場合（権限エラー）
        if (err.response.status === 403) {
          // 画面上部にエラーメッセージを表示する
          this.error_msg_list.push(this.forbidden_message);

          // 画面一番上へスクロールする
          this.pageTopScroll();
        }

        // エラーメッセージがある場合
        if (err.response.data.error_list !== null && err.response.data.error_list !== undefined) {
          // エラー要素の取得
          const errList = err.response.data.error_list
          // 各要素のエラーメッセージを出力する
          errList.forEach((objErr) => {
            let target = objErr.target
            let errorMsg = objErr.error_msg

            // targetが未定義である場合
            if (typeof target === 'undefined') {
              // 画面上部にエラーメッセージを表示する
              this.error_msg_list.push(errorMsg)

              // 画面一番上へスクロールする
              this.pageTopScroll();
            }
            else {
              // 対象の項目にエラーメッセージセット・スクロール先設定
              this.responseErrorMessage(target, errorMsg)
            }
          })
        }

        // エラーが発生した項目までスクロールする
        this.scrollToAnchor(this.errorHash)
      })
    },
    createRequestData() {
      let requestData = {}
      // 契約番号
      requestData["contract_no"] = this.value.contract_no
      // ユーザー数
      if (this.value.chat_user !== null && this.value.chat_user !== "") {
        requestData["chat_user"] = this.value.chat_user
      }
      // オプションサービス チェックボックス
      if (this.value.option === true) {
        requestData["option"] = 1
      }
      // ディスク増設 チェックボックス
      if (this.value.disk === true) {
        requestData["disk"] = 1
      }
      // ディスク増設 増設容量
      if (this.value.disk_size !== null && this.value.disk_size !== "") {
        requestData["disk_size"] = this.value.disk_size
      }
      // セキュリティオプションチェックボックス
      if (this.value.security === true) {
        requestData["security"] = 1
      }
      // BASIC認証 チェックボックス
      if (this.value.basic === true) {
        requestData["basic"] = 1
      }
      // BASIC認証 ユーザーID
      if (this.value.basic_id !== null && this.value.basic_id !== "") {
        requestData["basic_id"] = this.value.basic_id
      }
      // BASIC認証 パスワード
      if (this.value.basic_password !== null && this.value.basic_password !== "") {
        requestData["basic_password"] = this.value.basic_password
      }
      // BASIC認証 認証を除外するIPアドレス
      if (this.value.basic_except_ip !== null && this.value.basic_except_ip !== "") {
        requestData["basic_except_ip"] = this.value.basic_except_ip
      }
      // 接続元IPアドレス制限
      if (this.value.connect_permit === true) {
        requestData["connect_permit"] = 1
      }
      // 接続を許可するIPアドレス
      if (this.value.connect_permit_ip !== null && this.value.connect_permit_ip !== "") {
        requestData["connect_permit_ip"] = this.value.connect_permit_ip
      }
      // サブドメイン名
      if (this.value.sub_domain !== null && this.value.sub_domain !== "") {
        requestData["sub_domain"] = this.value.sub_domain
      }
      // お見積番号
      if (this.value.estimate !== null && this.value.estimate !== "") {
        requestData["estimate"] = this.value.estimate
      }
      // 無料お試し版からのデータ移行
      if (this.value.migration === true) {
        requestData["migration"] = 1
      }
      // 試使用環境URL
      if (this.value.migration_url !== "" && this.value.migration === true) {
        requestData["migration_url"] = this.value.migration_url
      }
      // 作業日時
      if (this.value.migration_date !== "" && this.value.migration_time_from !== null && this.value.migration === true) {
        requestData["migration_date"] = this.value.migration_date
        requestData["migration_time_from"] = this.value.migration_time_from
        requestData["migration_time_to"] = this.value.migration_time_to
      }
      // ご利用開始希望日
      if (this.value.preferred_date !== null && this.value.preferred_date !== "") {
        requestData["preferred_date"] = this.value.preferred_date
      }
      // 備考
      if (this.value.remarks !== null && this.value.remarks !== "") {
        requestData["remarks"] = this.value.remarks
      }
      // サービス利用規約
      if (this.value.provision === true) {
        requestData["provision"] = 1
      }

      return requestData
    },
    responseErrorMessage(target, msg) {
      // 現在のスクロール先インデックス
      let hashIndex = this.chatAnchorList.indexOf(this.errorHash)

      switch (target) {
        // ユーザー数
        case "chat_user":
          this.chat.error_msg.push(msg)
          this.errorHash = this.chatAnchorList[0]
          break
        // ディスク増設 増設容量
        case "chat_option_disk_size":
          this.option_disk_size.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 1 ? this.chatAnchorList[1] : this.errorHash
          break
        // BASIC認証 ユーザーID
        case "chat_basic_auth_user":
          this.basic_auth_user.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 2 ? this.chatAnchorList[2] : this.errorHash
          break
        // BASIC認証 パスワード
        case "chat_basic_auth_password":
          this.basic_auth_password.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 2 ? this.chatAnchorList[2] : this.errorHash
          break
        // BASIC認証 認証を除外するIPアドレス
        case "chat_basic_auth_ip":
          this.basic_auth_ip.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 2 ? this.chatAnchorList[2] : this.errorHash
          break
        // 接続元IPアドレス制限
        case "connect_permit_ip":
        case "chat_ip_restrictions_ip":
          this.ip_restrictions_ip.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 2 ? this.chatAnchorList[2] : this.errorHash
          break
        // サブドメイン名
        case "sub_domain":
        case "chat_sub_domain":
          this.sub_domain.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 3 ? this.chatAnchorList[3] : this.errorHash
          break
        // 無料お試し版からのデータ移行 試使用環境URL
        case "migration_url":
        case "chat_migration_url":
          this.migration_url.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.chatAnchorList[5] : this.errorHash
          break
        // 無料お試し版からのデータ移行
        case "migration_date":
        case "migration_datetime":
        case "migration_time_from":
        case "migration_time_to":
          this.migration_datetime.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 5 ? this.chatAnchorList[5] : this.errorHash
          break
        // ご利用開始希望日
        case "preferred_date":
          this.preferred_date.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 6 ? this.chatAnchorList[6] : this.errorHash
          break
        // お見積番号
        case "estimate":
          this.estimate.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 4 ? this.chatAnchorList[4] : this.errorHash
          break
        // 備考
        case "remarks":
          this.remarks.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 7 ? this.chatAnchorList[7] : this.errorHash
          break
        // サービス利用規約
        case "provision":
          this.provision_check.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 8 ? this.chatAnchorList[8] : this.errorHash
          break
        // ChatLuck組み合わせの該当箇所にエラーメッセージを追加
        // 「BASIC認証」の「除外IPあり」 ＋ 「接続元IPアドレス制限」
        case 'chat_basic_except_permit':
          this.basic_auth.error_msg.push(msg)
          this.ip_restrictions.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 2 ? this.chatAnchorList[2] : this.errorHash
          break
      }
    },
    /**
     * エラー表示をリセットする
     */
    resetError () {
      // 全てのエラーメッセージ要素を空にする
      this.error_msg_list                = [] // 画面上部のエラーメッセージ
      this.chat.error_msg                = [] // ChatLuck ユーザー数
      this.option_disk_size.error_msg    = [] // ディスク増設 増設容量
      this.basic_auth.error_msg          = [] // BASIC認証チェックボックス
      this.basic_auth_user.error_msg     = [] // BASIC認証ユーザーID
      this.basic_auth_password.error_msg = [] // BASIC認証パスワード
      this.basic_auth_ip.error_msg       = [] // BASIC認証認証を除外するIPアドレス
      this.ip_restrictions.error_msg     = [] // 接続元IPアドレス制限チェックボックス
      this.ip_restrictions_ip.error_msg  = [] // 接続元IPアドレス制限接続を許可するIPアドレス
      this.sub_domain.error_msg          = [] // ご希望サブドメイン名
      this.estimate.error_msg            = [] // お見積番号
      this.migration_url.error_msg       = [] // 無料お試し版からのデータ移行試使用環境URL

      // 無料お試し版からのデータ移行作業日付
      // 無料お試し版からのデータ移行作業時刻（から）
      // 無料お試し版からのデータ移行作業時刻（まで）
      this.migration_datetime.error_msg = []

      this.preferred_date.error_msg  = [] // ご利用開始希望日
      this.remarks.error_msg         = [] // 備考
      this.provision_check.error_msg = [] // サービス利用約款などチェックボックス
      this.errorHash                 = '' // エラー発生時のスクロール先を初期化する

    }
  },
  computed: {
    showMigrationTime() {
      let sDatetime = "選択してください"

      if (this.value.migration_date) {
        // 形式は「2021年11月14日 11:00 - 12:00」
        const arDay = this.value.migration_date.split("-")
        const sTime = this.value.migration_time_from + ":00 - " + this.value.migration_time_to + ":00"

        sDatetime = arDay[0] + "年" + arDay[1] + "月" + arDay[2] + "日 " + sTime;
      }

      return sDatetime
    },
  }
}
</script>

<style scoped>
.neo-title-bg-color {
  background-color: #f2ffff;
}
.datepicker-size {
  width: 210px;
}
::v-deep .datetime-label {
  padding-right: 53px !important;
}
.datetime-text {
  font-size: 1rem;
  margin-top: 1px;
}
.description-text-position {
  margin-top : -3px;
}
.detail-button-size {
  height: 22px;
  font-size: 11px;
  display: flex;
  align-items: center;
}

.estimate-size {
  width: 400px !important;
}

.label-font-size {
  font-size: 16px;
}

.neo-b-collapse {
  background-color: #f2ffff;
}
.neo-image-size {
  width: 300px;
  height: 110px;
}

.option-disk-form-class {
  width: 85px !important;
}

.paid-leave-option-description-font {
  font-size: 12.8px;
}
.paid-leave-option-font {
  font-size: 0.875rem;
}

.sub-b-collapse {
  width: 650px;
  padding: 5px;
  background-color: #ffffd3;
  margin-left: 15px;
}
.sub-b-container {
  width: 650px;
  padding: 5px;
  margin-left: 15px;
}

.white-space {
  white-space: pre-line !important;
}
.chat-title-bg-color {
  background-color: #f0ffe0;
}
</style>
